import { ZineAuthor } from '@components/zineAuthor/ZineAuthor';

import { listFormat } from '@common/utils/format';
import { DatoZineAuthorRecord } from '@interfaces';

type ZineBylineProps = {
	authors: DatoZineAuthorRecord[];
};

export const ZineByline = ({ authors }: ZineBylineProps) => {
	if (!authors.length) {
		return null;
	}

	const authorElements = authors.map((author) => {
		return <ZineAuthor author={author} key={author.id} />;
	});

	const listFormattedZineAuthorElements = listFormat(authorElements);

	return <p className="font-t6-medium">By {listFormattedZineAuthorElements}</p>;
};
